var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_105_9796)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F7F8F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9609 22.0781H16.0391C14.3913 22.0781 13.0508 23.4186 13.0508 25.0664V39.0117C13.0508 40.6595 14.3913 42 16.0391 42H35.9609C37.6087 42 38.9492 40.6595 38.9492 39.0117V25.0664C38.9492 23.4186 37.6087 22.0781 35.9609 22.0781ZM26 38.0156C25.4499 38.0156 25.0039 37.5696 25.0039 37.0195C25.0039 36.4693 25.4499 36.0234 26 36.0234C26.5501 36.0234 26.9961 36.4693 26.9961 37.0195C26.9961 37.5696 26.5501 38.0156 26 38.0156ZM27.7723 31.4573C27.286 31.8153 26.9961 32.3873 26.9961 32.9885C26.9961 33.539 26.5506 34.0079 26 34.0079C25.4494 34.0079 25.0039 33.5858 25.0039 33.0352C25.0039 31.757 25.5973 30.5849 26.5895 29.8534C26.8482 29.6636 26.9961 29.3708 26.9961 29.0508C26.9961 28.5012 26.5486 28.0547 26 28.0547C25.4514 28.0547 25.0039 28.5012 25.0039 29.0508C25.0039 29.6014 24.5584 30.0469 24.0078 30.0469C23.4572 30.0469 23.0117 29.6014 23.0117 29.0508C23.0117 27.403 24.3522 26.0625 26 26.0625C27.6478 26.0625 28.9883 27.403 28.9883 29.0508C28.9883 29.9963 28.5331 30.8961 27.7723 31.4573Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0117 20.0859V16.9648C23.0117 15.317 24.3522 13.9766 26 13.9766C27.6478 13.9766 28.9883 15.317 28.9883 16.9648V20.0859H34.9648V16.9648C34.9648 12.0247 30.9538 8 26 8C21.0565 8 17.0352 12.0214 17.0352 16.9648V20.0859H23.0117Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 22H36C37.6569 22 39 23.3431 39 25V39C39 40.6569 37.6569 42 36 42H29V22Z",
    fill: "#6DB5DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_105_9796",
    x: 0.5,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_9796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_9796",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotSvg);
export default __webpack_public_path__ + "static/media/ForgotSvg.5841532f0e9e0efbfc86c610e8f0491a.svg";
export { ForwardRef as ReactComponent };